import type { StaffAppointmentsViewModel } from "@lumora/core";
import { useViewModel } from "@lumora/ui";

interface Props {
  vm: StaffAppointmentsViewModel;
}

export default function StaffAppointmentsView({ vm }: Props) {
  const state = useViewModel(vm);

  if (!vm.canAccess()) {
    return <p className="text-sm text-gray-500">Your role cannot manage appointments.</p>;
  }

  return (
    <section className="space-y-4">
      <h2 className="text-lg font-bold">Appointments</h2>
      {state.error && <p className="text-sm text-red-600">{state.error}</p>}
      {state.loading && <p className="text-sm text-gray-500">Loading…</p>}
      {!state.loading && state.appointments.length === 0 && (
        <p className="text-sm text-gray-500">No appointments in the queue.</p>
      )}
      <ul className="divide-y divide-gray-100 rounded-lg border border-gray-100 bg-white">
        {state.appointments.map((appt) => (
          <li key={appt.id} className="flex flex-wrap items-center justify-between gap-3 p-4 text-sm">
            <div>
              <p className="font-semibold">{appt.customerName}</p>
              <p className="text-gray-500">
                {appt.phone} · {new Date(appt.startsAt).toLocaleString()} · {appt.status}
              </p>
            </div>
            {appt.status === "pending" && (
              <div className="flex gap-2">
                <button
                  type="button"
                  className="rounded bg-green-600 px-3 py-1 text-xs font-bold uppercase text-white"
                  onClick={() => void vm.accept(appt.id)}
                >
                  Accept
                </button>
                <button
                  type="button"
                  className="rounded bg-gray-200 px-3 py-1 text-xs font-bold uppercase"
                  onClick={() => void vm.decline(appt.id)}
                >
                  Decline
                </button>
              </div>
            )}
            {appt.status === "accepted" && (
              <button
                type="button"
                className="rounded bg-red-100 px-3 py-1 text-xs font-bold uppercase text-red-700"
                onClick={() => void vm.cancel(appt.id)}
              >
                Cancel
              </button>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}
